export const RESOURCE = 'user_catalog.publication_premieres';

export const PREMIERE_SHOW_TABS = ['general'] as const;

export type PremiereShowTab = (typeof PREMIERE_SHOW_TABS)[number];

export const PREMIERE_DEFAULT_TAB: PremiereShowTab = 'general';
